import React, { useCallback, useEffect, useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { HeaderSpacer } from '../components/Header';
import SiteHeroPage from '../components/SiteHeroPage';
import { OutlinedButton, PageBackground } from '../components/common/hero/styles';
import { TEXT_DARK, TEXT_SECONDARY } from '../components/common/tokens';
import { getNamespacePath, selectContext, selectContextStatus } from '../redux/features/context/contextSlice';
import { fetchSiteById } from '../redux/features/sites/sitesSlice';
import StyledBackdrop from '../components/StyledBackdrop';
import Login from '../components/Login';
import { hasFlag, withoutFlag } from '../common/UrlFlags';

export default function SiteReadView(props) {
  const { namespace: propNamespace } = props;
  const { siteId } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const { userInfo } = useSelector((state) => state.users);
  const status = useSelector(selectContextStatus);
  const currContext = useSelector(selectContext);

  const namespace = propNamespace || (userInfo ? 'private' : 'public');

  const loadSite = useCallback(
    () => dispatch(fetchSiteById({ namespace, siteId })),
    [dispatch, namespace, siteId],
  );

  const [startInEdit] = useState(() => hasFlag(searchParams, 'edit'));
  useEffect(() => {
    if (hasFlag(searchParams, 'edit')) {
      setSearchParams(withoutFlag(searchParams, 'edit'), { replace: true });
    }
  }, [searchParams, setSearchParams]);

  useEffect(() => {
    loadSite();
  }, [loadSite]);

  let rawSite;
  let forceSignIn = false;
  let notFound = false;

  if (currContext?.type === 'site' && currContext.site?.id === siteId) {
    rawSite = currContext.site;
  } else if (status !== 'loading' && currContext?.type === 'site' && !currContext.site) {
    forceSignIn = true;
  } else if (status === 'failed') {
    if (userInfo) {
      notFound = true;
    } else {
      forceSignIn = true;
    }
  }

  const showSpinner = !forceSignIn && !notFound && !rawSite;

  return (
    <>
      <HeaderSpacer />
      {forceSignIn && <Login />}
      {notFound && (
        <PageBackground>
          <div style={{ textAlign: 'center', paddingTop: 48 }}>
            <h2 style={{ color: TEXT_DARK, fontWeight: 700, margin: '0 0 8px' }}>
              Site not found
            </h2>
            <p style={{ color: TEXT_SECONDARY, margin: '0 0 20px' }}>
              This site does not exist or is no longer available.
            </p>
            <OutlinedButton
              type="button"
              onClick={() => navigate(`/${getNamespacePath(namespace)}/sites`)}
            >
              Browse sites
            </OutlinedButton>
          </div>
        </PageBackground>
      )}
      {showSpinner && (
        <StyledBackdrop open>
          <CircularProgress color="inherit" />
        </StyledBackdrop>
      )}
      {!forceSignIn && !notFound && rawSite && (
        <SiteHeroPage
          site={rawSite}
          namespace={namespace}
          startInEdit={startInEdit}
          onRefetch={loadSite}
        />
      )}
    </>
  );
}
